import { useRef } from "react";
import "./App.css";
import { Provider } from "react-redux";
import { AppStore, makeStore } from "./store/store";
import "./App.css";
import Init from "./Init";
import ErrorBoundary from "./components/ErrorBoundry";

function App() {
  const storeRef = useRef<AppStore>(null);

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  return (
    <Provider store={storeRef.current}>
      <ErrorBoundary>
        <Init />
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
